export interface ReactionView { emoji: string; count: number; mine: boolean }
export interface WireReaction extends ReactionView { accountIds?: string[] }

/** Ownership belongs to the viewer, never to the message author. */
export function reactionsForViewer(reactions: readonly WireReaction[], accountXid: string): ReactionView[] {
  return reactions.map(reaction => {
    if (!reaction.accountIds) return reaction;
    const accounts = new Set(reaction.accountIds);
    return { emoji: reaction.emoji, count: accounts.size, mine: accounts.has(accountXid) };
  });
}

/** Apply a desired state, not an increment; repeated updates are idempotent. */
export function setOwnReaction(reactions: readonly ReactionView[], emoji: string, mine: boolean): ReactionView[] {
  const previous = reactions.find(reaction => reaction.emoji === emoji);
  const count = (previous?.count ?? 0) + (mine ? 1 : 0) - (previous?.mine ? 1 : 0);
  const others = reactions.filter(reaction => reaction.emoji !== emoji);
  return count > 0 ? [...others, { emoji, count, mine }] : others;
}
